// extracted by mini-css-extract-plugin
module.exports = {"subTitle":"view-product_subTitle_2biar","subUnsub":"view-product_subUnsub_2tuMd"};